export default __webpack_public_path__ + "media/images/logo/vk-533031845bcab2734cf965f7648c0972.svg";